import { FC } from "react";
import { useBreakpointValue } from "@chakra-ui/react";
import {
  PanelContentContainer,
  HeadingWithHighlight,
} from "~/OnboardingApp/components";
import { Steps } from "./Steps";

export const LeftRAFSection: FC = () => {
  const highlightColor = "var(--chakra-colors-newPeach-300)";
  const key =
    useBreakpointValue({
      base: "onboarding.welcomePage.heading.mobile" as const,
      lg: "onboarding.welcomePage.heading.desktop" as const,
    }) ?? ("onboarding.welcomePage.heading.desktop" as const);

  return (
    <PanelContentContainer bg="th.yellow1">
      <HeadingWithHighlight highlightColor={highlightColor} i18nKey={key} />
      <Steps />
    </PanelContentContainer>
  );
};
